import { Tabs } from 'antd'
import React, { useEffect, useMemo } from 'react'
import { LibraryCategory } from 'src/pages/Library'
import { getContentCategoryTitle, getContentTabs, LearningContentType } from 'src/utils/content'

export const CONTENT_TABS: LearningContentType[] = [
  'asset',
  'course',
  'learningpath',
  'playlist',
  'feedpost',
  'prompt',
  'dealroom',
  'opportunity',
  'call',
]

const ContentTabs: React.FC<{
  activeKey?: string
  tabChanged: (key: LibraryCategory | LearningContentType) => void
  excludeTabs?: (LibraryCategory | LearningContentType)[]
  overrideTabs?: (LibraryCategory | LearningContentType)[]
}> = ({ activeKey, tabChanged, excludeTabs = [], overrideTabs }) => {
  const tabs = useMemo(() => {
    let contentTabs = overrideTabs ?? CONTENT_TABS
    if (excludeTabs) {
      contentTabs = contentTabs.filter((tab) => !excludeTabs.includes(tab))
    }
    return getContentTabs(contentTabs)
  }, [excludeTabs, overrideTabs])

  useEffect(() => {
    if (!activeKey) {
      tabChanged(tabs[0])
    }
  }, [activeKey, tabChanged, tabs])

  return (
    <Tabs
      activeKey={activeKey}
      onChange={tabChanged}
      items={tabs.map((tab) => ({ key: tab, label: getContentCategoryTitle(tab) }))}
    />
  )
}

export default ContentTabs
